import type { DateRange } from '@fv/models'
import type { HintedString } from '@fv/models/core'

type DateOption = {
  text: string
  value: DateRange
}

export const dateOptions: DateOption[] = [
  { text: 'This year', value: 'this-year' },
  { text: 'Today', value: 'today' },
  { text: 'Tomorrow', value: 'tomorrow' },
  { text: 'Yesterday', value: 'yesterday' },
  { text: 'This week', value: 'this-week' },
  { text: 'Next week', value: 'next-week' },
  { text: 'Last 7 days', value: 'last-7-days' },
  { text: 'This month', value: 'this-month' },
  { text: 'Last month', value: 'last-month' },
  { text: 'Last 30 days', value: 'last-30-days' },
  { text: 'Last 3 months', value: 'last-3-months' },
  { text: 'Last 12 months', value: 'last-12-months' },
]
const dateRangeLabels = Object.fromEntries(
  dateOptions.map(o => [o.value, o.text]),
) as Record<DateRange, string>

export const pastDateOptions = dateOptions.filter(
  o => o.value !== 'tomorrow' && o.value !== 'next-week',
)

export const getDateRangeLabel = (value: HintedString<DateRange>) => {
  return dateRangeLabels[value as DateRange] ?? null
}
